import { Typography } from "@mui/material";
import Title from "Components/Card/title";
import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";
import { INVOICE_TYPE } from "Components/Constants/InvoiceType";
import { INVOICE_TYPE_CODE } from "Components/Constants/InvoiceTypeCode";
import { KOT_STATUS, KOT_STATUS_LABEL } from "Components/Constants/KotStatus";
import TableView from "Components/MUI_components/Table/table";
import { getKotStatus, getKotStatusBgColor } from "Helper/kot";
import React from "react";
import KotServiceService from "Service/Kot/KotService.service";

const ListOfKOTs = () => {
  const tableHeadCells = [
    {
      id: (row) => {
        return row?.code;
      },
      numeric: false,
      disablePadding: false,
      label: COLUMNS_NAME.CODE,
    },
    {
      id: (row) => {
        return row?.createdAt;
      },
      numeric: false,
      disablePadding: false,
      label: COLUMNS_NAME.DATE,
    },
    {
      id: (row) => {
        return row?.desk?.deskName ?? "-";
      },
      numeric: false,
      disablePadding: false,
      label: COLUMNS_NAME.DESK_NAME,
    },
    {
      id: (row) => {
        // console.log(row?.invoiceType);

        const invoiceTypeCode = row?.invoiceType;
        const kotType =
          invoiceTypeCode == INVOICE_TYPE_CODE.TAKE_AWAY
            ? INVOICE_TYPE.TAKE_AWAY
            : invoiceTypeCode == INVOICE_TYPE_CODE.DELIVERY
              ? INVOICE_TYPE.DELIVERY
              : INVOICE_TYPE.DINE;

        return kotType;
      },
      numeric: false,
      disablePadding: false,
      label: COLUMNS_NAME.KOT_TYPE,
    },
    {
      id: (row) => {
        const kotInvoiceStatusCode = row?.invoiceStatus;

        return (
          <Typography
            sx={{
              bgcolor: getKotStatusBgColor(kotInvoiceStatusCode),
              fontSize: 12,
              width: "fit-content",
              px: 1,
              py: 0.5,
              color: "#fff",
              borderRadius: 1,
            }}
          >
            {getKotStatus(kotInvoiceStatusCode)}
          </Typography>
        );
      },
      numeric: false,
      disablePadding: false,
      label: COLUMNS_NAME.STATUS,
    },
  ];

  return (
    <>
      <Title>List of Kot(s)</Title>
      <TableView
        title="List of Kot(s)"
        headCells={tableHeadCells}
        service={KotServiceService}
        withoutLocationFilter
        addReversalFunction
        reversalService={KotServiceService}
      />
    </>
  );
};

export default ListOfKOTs;
